<template>
  <div class="card h-100">
    <div
      class="card-header bg-light d-flex justify-content-between align-items-center"
      :title="tooltip"
      data-toggle="tooltip"
      data-placement="top"
      data-delay="300"
    >
      <h6 class="mb-0 text-dark font-weight-bold">{{ title }}</h6>
      <span class="badge badge-primary">{{ totalCount }}</span>
    </div>
    <div class="card-body">
      <div v-if="totalCount === 0" class="text-center text-muted py-3">
        <fa icon="inbox" class="mb-2" />
        <p class="mb-0">
          No reports meet the established criteria for this category. For a full list of reports,
          <a href="#" @click.prevent="scrollToInterviews" class="text-primary scroll-link">click here</a>.
        </p>
      </div>
      <div v-else>
        <InterviewBucketList :organizationId="organizationId" :interviews="interviews" @star-updated="onStarUpdated" />
      </div>
    </div>
  </div>
</template>

<script>
import InterviewBucketList from "./InterviewBucketList.vue";

export default {
  components: {
    InterviewBucketList,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: "",
    },
    interviews: {
      type: Array,
      default: () => [],
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    organizationId: {
      type: String,
      required: true,
    },
  },
  methods: {
    onStarUpdated(updatedInterview) {
      // Emit the star update event to the parent component
      this.$emit("star-updated", updatedInterview);
    },
    scrollToInterviews() {
      // Look for the card containing the interviews section by header text
      const cards = document.querySelectorAll(".card");
      let target = null;

      for (const card of cards) {
        const header = card.querySelector("h5");
        if (header && header.textContent.includes("Investigation Interview Dashboard")) {
          target = card;
          break;
        }
      }

      // Scroll to the target element
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
  mounted() {
    // Initialize Bootstrap tooltips
    if (this.tooltip && window.$ && window.$.fn.tooltip) {
      window.$(this.$el.querySelector('[data-toggle="tooltip"]')).tooltip();
    }
  },
  beforeDestroy() {
    // Clean up tooltips
    if (window.$ && window.$.fn.tooltip) {
      window.$(this.$el.querySelector('[data-toggle="tooltip"]')).tooltip("dispose");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.card-header {
  cursor: help;

  h6 {
    font-size: 0.9rem;
    line-height: 1.3;
  }
}

.badge {
  font-size: 0.75rem;
}

.scroll-link {
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
